import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { PEOPLE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { QUERY_KEY } from '@/features/ManageContacts/common';
import type { People, RouteParam } from '@/types';

type AxiosResponse = {
  results: People[];
};

export const usePeople = (contacts: string[], source: string) => {
  const { category } = useParams<RouteParam>();

  const { data, isError, isLoading } = useQuery(
    [QUERY_KEY, source, ...contacts],
    ({ signal }) =>
      axiosInstance.get<AxiosResponse>(PEOPLE_API_ROUTES.contactInfo(), {
        params: { contacts: JSON.stringify(contacts), source },
        signal,
      }),
    {
      select: (data) => data.data.results,
      enabled: contacts.length > 0 && category !== 'channels',
    }
  );

  return { data, isError, isLoading };
};
